import './base';
import Splide from '@splidejs/splide';
import {
  Category
} from './src/category';
import {
  initSlider
} from './src/photo-slider';
import {
  loadLazyProducts
} from './src/lazy-products';

new Category();

const mainTracing = document.querySelector('.main-tracing__splide');

if (mainTracing) {
  new Splide('.main-tracing__splide', {
    autoWidth: true,
    pagination: false,
    arrows: false,
    mediaQuery: 'min',
    breakpoints: {
      '992': {
        destroy: true,
      },
    },
  }).mount();
}

loadLazyProducts();

initSlider();

